"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE = '__NATIVE_FILE__';
exports.URL = '__NATIVE_URL__';
exports.TEXT = '__NATIVE_TEXT__';



//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/lib/cjs/NativeTypes.js
// module id = 255
// module chunks = 0